<template>
  <div class="nav-con">
    <div
      :class="currentNav === item.routeName ? 'select-active' : ''"
      v-for="(item, index) in menuArr"
      :key="index"
    >
      <div class="bottom-item" @click="changeNav(item)">
        <div
          class="icon"
          :style="{ backgroundImage: `url(${item.icon})` }"
        ></div>
        <div class="title">{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  computed: {
    ...mapState(["currentNav"]),
    ...mapGetters(["setNav"]),
  },
  data() {
    return {
      menuArr: [
        {
          name: "首页",
          icon: require("../assets/home/yqgk@2x.png"),
          routeName: "Home",
        },
        {
          name: "智慧照护",
          icon: require("../assets/home/ynfw@2x.png"),
          routeName: "Service",
        },
        {
          name: "智能设备",
          icon: require("../assets/home/afjk@2x.png"),
          routeName: "Security",
        },
        {
          name: "使用统计",
          icon: require("../assets/home/sjkb@2x.png"),
          routeName: "DataBoard",
        },
      ],
    };
  },
  methods: {
    changeNav(item) {
      this.$router.push({ name: `${item.routeName}` });
    },
  },
};
</script>

<style lang="scss" scoped>
.nav-con {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 30px;
}
.bottom-item {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  cursor: pointer;
  &:hover {
    filter: brightness(1.2);
  }
  .icon {
    width: 103px;
    height: 81px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
  .title {
    margin-top: 20px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    line-height: 28px;
  }
}
.select-active {
  width: 150px;
  height: 150px;
  border: 1px solid #3477ae;
  border-radius: 8px;
  background: rgba(54, 196, 255, 0.16);
  display: flex;
  justify-content: center;
}
</style>
